<template>
    <v-form ref="chiefComplaintForm" v-model="currentChiefComplaint.isValid">
        <v-container class="py-0 py-sm-0">
            <v-row>
                <v-col class="pl-10 py-0 py-sm-0" style="min-height: 445px;">
                    <div v-if="showVisitType">
                        <label for="VisitType" v-if="showVisitType">{{ currentModel.settings.localizedContent['walkin_form_visitType_field_label'] }}</label>
                        <v-select v-model="currentClientDepartments.formData.selectedDepartments"
                                  v-if="showVisitType"
                                  :items="clientDepartments"
                                  :allow-overflow="false"
                                  :rules="visitTypeRules"
                                  :disable-lookup="true"
                                  class="mt-1"
                                  name="VisitType"
                                  id="visitType"
                                  ref="visitType"
                                  :placeholder="currentModel.settings.localizedContent['walkin_form_visitType_field_watermark'] "
                                  background-color="white"
                                  outlined
                                  solo>
                        </v-select>
                        <v-icon class="input-valid" v-if="visitTypeValid" color="secondary" style="top:-72px;">mdi-check</v-icon>
                    </div>
                    <div style="height: 150px;" v-if="showChiefComplaint">
                        <label v-if="showChiefComplaint" for="ChiefComplaint">{{ currentModel.settings.localizedContent['walkin_form_chief_complaint_field_label'] }}</label>
                        <v-textarea v-model="currentChiefComplaint.formData.chiefComplaint"
                                    v-if="showChiefComplaint"
                                    id="chiefComplaint"
                                    ref="chiefComplaint"
                                    :placeholder="currentModel.settings.localizedContent['reservation_symptoms_placeholder']"
                                    class="mt-1"
                                    style="padding-top: 3px;"
                                    required
                                    height="100"
                                    :rules="chiefComplaintRules"
                                    :auto-grow="false"
                                    :no-resize="true"
                                    background-color="white"
                                    dense
                                    solo
                                    outlined>
                        </v-textarea>
                        <v-icon class="input-valid" v-if="chiefComplaintValid" color="secondary" style="top:-88px;">mdi-check</v-icon>
                    </div>

                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import ContextualMixin from '../mixins/contextualMixin'
    import WalkinMixin from '../mixins/walkinFormMixin'

    /*eslint-disable no-useless-escape*/
    export default {
        name: 'ChiefComplaint',
        mixins: [ContextualMixin, WalkinMixin],
        data() {
            return {
                chiefComplaintRules: [
                    v => !!v || 'Reason for visit is required.',
                    v => /^[a-zA-Z0-9 \r\n!@#$&%?°*'’()=\-_`´.+:;,/\"]*$/.test(v) || 'Reason for visit is invalid.'
                ],
                visitTypeRules: [
                    v => !!v || 'Visit type is required'
                ],
                visitTypeValid: false
            }
        },
        computed: {
            showDepartmentQuestion() {
                return this.currentModel.settings.showDepartmentQuestion
            },
            clientDepartments() {
                if (!this.showVisitType)
                    return [];
                return this.currentModel.settings.clientDepartments.filter(cd=> cd.isActive).map(x => {
                    return {
                        text: x.name,
                        value: x.id
                    }
                });
            },
            chiefComplaintValid() {
                if (!this.currentChiefComplaint.formData.chiefComplaint || !this.$refs.chiefComplaintForm)
                    return false;
                return this.$refs.chiefComplaint.validate();
            }
        },
        watch: {
            'currentClientDepartments.formData.selectedDepartments'(departments) {
                this.visitTypeValid = departments && departments > 0;
            }
        }
    }
</script>
